'use client';

import type { ButtonClickEvent } from '@hc-frontend/core-ui';
import { useEventBus, useTrackingContexts } from '@hc-frontend/core-ui';
import type React from 'react';
import type { ReactNode } from 'react';

export function TypLinkEnroll({
  children,
  ...props
}: React.LinkHTMLAttributes<HTMLAnchorElement> & { children: ReactNode }) {
  const eventBus = useEventBus();
  const contexts = useTrackingContexts();

  return (
    <a
      {...props}
      onClick={(event) => {
        eventBus.publish<ButtonClickEvent>({
          id: 'quotes-enroll',
          topic: 'core.ui.button.click',
          source: event.currentTarget,
          contexts,
        });
      }}
    >
      {children}
    </a>
  );
}
